/**
 * Branding Configuration
 * Zentrale Konfiguration für Logo und Markendesign
 */

// Logo für dunkle Hintergründe (weiße + grüne Schrift)
export const LOGO_DARK_BG = "https://customer-assets.emergentagent.com/job_case-flow-2/artifacts/bx4w7mjc_IMG_1370.png";

// Logo für helle Hintergründe (nur grüne Schrift)
export const LOGO_LIGHT_BG = "https://customer-assets.emergentagent.com/job_gutachten-preview/artifacts/gusc9edr_image.png";

// Standard Logo (für dunkle Hintergründe)
export const LOGO_URL = LOGO_DARK_BG;

// Logo Größen
export const LOGO_SIZES = {
  sm: 'h-8',
  md: 'h-10',
  lg: 'h-12',
  xl: 'h-14'
};

// Header Styles für einheitliches Design
export const HEADER_STYLES = {
  dark: 'bg-slate-900 border-b border-slate-700',
  gradient: 'bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900',
};
